var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-cell-tags"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.tags)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }